// 开发环境域名

const host_development = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API : ''
const ws_domain = process.env.VUE_APP_WS_API ? process.env.VUE_APP_WS_API : ''

const cdnURL = 'https://cdn.zczmer.com'
const zmDomain = 'https://shop.zczmer.com'
const isDebug = process.env.VUE_APP_IS_DEBUG === 'true'

export default {
    // 版本
    version: '3.5.0',
    baseURL: host_development,
    wsURL: ws_domain,
    cdnURL,
    zmDomain,
    isDebug
}
